import { Turbo } from '@hotwired/turbo-rails';
import TurboPower from 'turbo_power';

TurboPower.initialize(Turbo.StreamActions);
